<template>
  <icon src-file-name="x-black.png" />
</template>

<script>
import Icon from './icon'

export default {
  components: {
    Icon
  }
}
</script>

